// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  overflow-x: hidden;
  @media (max-width: 700px) {
    padding: 15px 23px;
    width: calc(100% - 46px);
  }
`;
const Inner = styled.div`
  width: 902px;

  background-color: #3949ab;
  padding: 31px 109px 43px 109px;

  font-family: Lato;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: 1.7px;
  text-align: center;
  color: #ffffff;

  @media (max-width: 1120px) {
    padding: ${scale(1120, 767, 31, 35, "vw")}
      ${scale(1120, 767, 109, 25, "vw")} ${scale(1120, 767, 43, 51, "vw")}
      ${scale(1120, 767, 109, 25, "vw")};
    width: 10px;
    flex-grow: 1;

    font-size: ${scale(1120, 767, 24, 21, "vw")};
    line-height: ${scale(1120, 767, 24 * 1.58, 21 * 1.52, "vw")};

    letter-spacing: 1.5px;
  }
  @media (max-width: 767px) {
    padding: 35px 25px 51px 25px;
  }
  @media (max-width: 700px) {
    padding: 20px 15px 25px 15px;
    width: calc(100% - 30px);

    font-size: 14px;
    line-height: 1.57;
    letter-spacing: 1px;
  }
`;

class BlueMessage extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Inner>{this.title()}</Inner>
      </Wrapper>
    );
  }
}

export default BlueMessage;



// WEBPACK FOOTER //
// ./src/components/BlueMessage.js